import { useContext } from 'react';

import { CategoricalBarChartScalesContext } from '../contexts/CategoricalBarChartScalesContext.js';

export const useCategoricalBarChartScales = () =>
  useContext(CategoricalBarChartScalesContext);
